<swiper
    *ngIf="!loading"
    [slidesPerView]="getSlidesPerView"
    [spaceBetween]="20"
    (swiper)="onSwiper($event)"
    (slideChange)="onSlideChange()"
    [navigation]="true"
    [pagination]="{ clickable: true }"
    [autoplay]="true"
>
  <ng-template *ngFor="let product of products" swiperSlide>
      <app-product-card [product]="product"></app-product-card>
  </ng-template>
</swiper>

<div *ngIf="loading" class="d-flex justify-content-center">
  <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>